import { AxiosResponse } from "axios";
import { BusinessHourRequest, DeleteCompanyBusinessHourRequest } from "@/main/models/request/businessHourRequest";
import { BusinessHourResponse } from "@/main/models/response";
import { Result } from "@/main/models/common/resultResponse";
import { api } from "../base/api";
import { ICompanyBusinessHourApi } from "../base";

const baseRoute: string = "CompanyBusinessHour";

export class CompanyBusinessHourApi extends ICompanyBusinessHourApi {
	saveBusinessHour(request: BusinessHourRequest): Promise<AxiosResponse<Result<BusinessHourResponse>>> {
		return api.post(`${baseRoute}/save`, request);
	}

	deleteBusinessHour(request: DeleteCompanyBusinessHourRequest): Promise<AxiosResponse<Result<BusinessHourResponse>>> {
		return api.post(`${baseRoute}/delete`, request);
	}
}
